import HTTP from "../http";
import Jsona from "jsona";

import paramsHelper from "../helpers/params";

const dataFormatter = new Jsona();

export default {
  async index(page, sort) {
    try {
      let res = await HTTP.normal.get(
        `/professionals?include=account.profile&page[number]=${page}&sort=${sort}`
      );

      return {
        data: dataFormatter.deserialize(res.data),
        meta: res.data.meta
      };
    } catch (e) {
      throw "Ocorreu um erro ao listar os profissionais!";
    }
  },

  async getById(id) {
    try {
      let res = await HTTP.normal.get(
        `/professionals/${id}?include=account.profile,account.schedule.events,account.phones`
      );

      return dataFormatter.deserialize(res.data);
    } catch (e) {
      throw "Ocorreu um erro ao buscar o profissional!";
    }
  },

  async create(payload) {
    try {
      let data = {
        data: {
          attributes: payload.professional,
          relationships: {
            account: {
              attributes: payload.account
            },
            profile: {
              attributes: payload.profile
            },
            phones: {
              attributes: [payload.phone]
            },
            address: payload.address
          }
        }
      };

      let professional = await HTTP.normal.post("/professionals", data);

      professional = dataFormatter.deserialize(professional.data);

      let document_type = "CPF";
      let document_number = professional.cpf;

      if (professional.mei && professional.mei != "") {
        document_type = "CNPJ";
        document_number = professional.mei;
      }

      let payment_data = {
        data: {
          type: "payment_gateway_accounts",
          attributes: {
            name: payload.account.first_name,
            alt_name: payload.account.last_name,
            document_type,
            document_number: parseInt(document_number),
            phone: payload.phone,
            address: payload.address
          },
          relationships: {
            account: {
              data: {
                type: "accounts",
                id: professional.account.id
              }
            }
          }
        }
      };

      let payment = await HTTP.normal.post(
        "/payment-gateway-accounts",
        payment_data
      );

      let payment_gateway = await HTTP.normal.post(
        "/payment-gateway-accounts/create-on-gateway",
        {
          data: {
            attributes: {
              account_id: professional.account.id
            }
          }
        }
      );
    } catch (e) {
      throw e.response.data;
    }
  },

  async getAvailables(data) {
    try {
      let res = await HTTP.normal.post(
        "/professionals/available?page[limit]=15",
        data
      );
      let professionals = dataFormatter.deserialize(res.data);

      if (professionals.length) {
        let schedule_events = res.data.included.filter(
          el => el.type === "schedule_events"
        );

        professionals.forEach(professional => {
          professional.schedule_event = schedule_events[0];
          schedule_events.splice(0, 1);
        });

        professionals = professionals.filter(
          professional => professional.schedule_event
        );
      }

      return professionals;
    } catch (e) {
      throw "Erro ao listar os profissionais disponíveis";
    }
  },

  async getAvailablesByDuration(data) {
    try {
      let res = await HTTP.normal.post(
        "/professionals/available-by-duration",
        data
      );
      let professionals = dataFormatter.deserialize(res.data);
      let events = [];

      if (res.data && res.data.included) {
        events = res.data.included.filter(
          element => element.type === "schedule_events"
        );
      }

      return { professionals, events: events.map(e => e.attributes) };
    } catch (e) {
      throw "Erro ao listar os profissionais disponíveis por evento";
    }
  },

  async getDistricts(id) {
    try {
      let res = await HTTP.normal.get(
        `/professionals/${id}?include=districts.city,districts.rating,districts.pricing`
      );
      return dataFormatter.deserialize(res.data).districts;
    } catch (e) {
      throw "Erro ao listar os distritos do profissional";
    }
  },

  async getAvailablesOnDistrictByName(payload) {
    try {
      let query = payload.query.replace(/ /g, ",");
      let res = await HTTP.normal.get(
        `/queries/professionals/available-on-district-by-name?professional_name=${query}&district_id=${
          payload.district_id
        }`
      );
      return dataFormatter.deserialize(res.data);
    } catch (e) {
      throw "Ocorreu um erro ao buscar os profissionais por distrito e por nome!";
    }
  },

  async updateProfessional(professional) {
    try {
      let data = {
        data: {
          type: "professionals",
          id: professional.id,
          attributes: {
            mei: professional.mei,
            rating: professional.rating
          }
        }
      };

      await HTTP.normal.patch(`/professionals/${professional.id}`, data);
    } catch (e) {
      throw "Ocorreu um erro ao atualizar os dados do profissional!";
    }
  },

  async updateAccount(account) {
    try {
      let data = {
        data: {
          type: "accounts",
          id: account.id,
          attributes: {
            first_name: account.first_name,
            last_name: account.last_name
          }
        }
      };

      await HTTP.normal.patch(`/accounts/${account.id}`, data);
    } catch (e) {
      throw "Ocorreu um erro ao atualizar a conta do profissional!";
    }
  },

  async updateProfile(profile) {
    try {
      let data = {
        data: {
          type: "profiles",
          id: profile.id,
          attributes: {
            profile_picture: profile.profile_picture,
            city_name: profile.city_name,
            state_name: profile.state_name
          }
        }
      };

      return await HTTP.normal.patch(`/profiles/${profile.id}`, data);
    } catch (e) {
      throw "Ocorreu um erro ao atualizar o perfil do profissional!";
    }
  },

  async addDistricts(payload) {
    try {
      let data = {
        data: {
          type: "professionals",
          id: payload.professional_id,
          relationships: {
            districts: {
              data: []
            }
          }
        }
      };

      payload.districts.forEach(district => {
        data.data.relationships.districts.data.push({
          type: "districts",
          id: district.id
        });
      });

      return await HTTP.normal.patch(
        `/professionals/${payload.professional_id}`,
        data
      );
    } catch (e) {
      throw "Erro ao relacionar distritos ao profissional";
    }
  },

  async getAvailableEvents(schedule_id) {
    try {
      let page_number = 1;
      let events = await HTTP.normal.get(
        `schedules/${schedule_id}/events?filter[status]=available&page[size]=50&page[number]=${page_number}&sort=-starts_at`
      );
      events = {
        data: dataFormatter.deserialize(events.data),
        meta: events.data.meta
      };
    } catch (e) {
      throw e;
    }
  }
};



// WEBPACK FOOTER //
// ./src/api/modules/professionals.js